import { render, staticRenderFns } from "./processNonImprove.vue?vue&type=template&id=8cd0510e"
import script from "./processNonImprove.vue?vue&type=script&lang=js"
export * from "./processNonImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd0510e')) {
      api.createRecord('8cd0510e', component.options)
    } else {
      api.reload('8cd0510e', component.options)
    }
    module.hot.accept("./processNonImprove.vue?vue&type=template&id=8cd0510e", function () {
      api.rerender('8cd0510e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processNonImprove.vue"
export default component.exports